import { z } from "zod";

import {
  languagesSchema,
  ReviewsLanguagesOptions,
} from "../../../../HookForm/LanguageSelect/types";
import {
  DEFAULT_PERIOD_OPTION,
  getTimespanFromPeriod,
} from "../../../../HookForm/TimespanSelect/const";

const searchKeywordsSchema = z.object({
  is_enabled: z.boolean(),
  ai_summary_enabled: z.boolean(),
});

const callsSchema = z.object({
  is_enabled: z.boolean(),
  ai_summary_enabled: z.boolean(),
  time_unit: z.enum(["day", "week", "month"]),
});

const routeSearchSchema = z.object({
  is_enabled: z.boolean(),
  ai_summary_enabled: z.boolean(),
  time_unit: z.enum(["day", "week", "month"]),
});

const websiteSchema = z.object({
  is_enabled: z.boolean(),
  ai_summary_enabled: z.boolean(),
  time_unit: z.enum(["day", "week", "month"]),
});

const reviewsSchema = z.object({
  is_enabled: z.boolean(),
  languages: languagesSchema,
});

export const schema = z.object({
  locations: z.array(z.object({ id: z.coerce.number(), name: z.string() })),
  timespan: z.object({
    start_date: z.date(),
    end_date: z.date(),
  }),
  options: z.object({
    search_keywords: searchKeywordsSchema,
    website: websiteSchema,
    calls: callsSchema,
    route_search: routeSearchSchema,
    reviews: reviewsSchema,
    overall_ai_summary: z.object({
      is_enabled: z.boolean(),
    }),
  }),
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (): Schema => {
  const period = DEFAULT_PERIOD_OPTION;
  const timespan = getTimespanFromPeriod(period);
  return {
    locations: [],
    timespan: {
      start_date: timespan.startDate ?? new Date(),
      end_date: timespan.endDate ?? new Date(),
    },
    options: {
      search_keywords: { is_enabled: true, ai_summary_enabled: true },
      website: { is_enabled: true, ai_summary_enabled: true, time_unit: "day" },
      calls: { is_enabled: true, ai_summary_enabled: true, time_unit: "day" },
      route_search: {
        is_enabled: true,
        ai_summary_enabled: true,
        time_unit: "day",
      },
      reviews: {
        is_enabled: true,
        languages: { option: ReviewsLanguagesOptions.ALL, custom_values: [] },
      },
      overall_ai_summary: { is_enabled: true },
    },
  };
};
